export default "__VITE_ASSET__1fa3d24a__"